import { IAuth } from "../interface/auth.interface";

export enum AuthActionKind {
    SET_TOKEN = 'SET_TOKEN',
    LOG_OUT = 'LOG_OUT',
    LOG_IN = 'LOG_IN',
}

// An interface for our actions
type AuthAction = {
    type: AuthActionKind.SET_TOKEN;
    token: string;
    loggin: boolean,
} | {
    type: AuthActionKind.LOG_IN;
    token: string;
} | {
    type: AuthActionKind.LOG_OUT;
};

export function authReducer(state: IAuth, action: AuthAction) {

    switch (action.type) {
        case AuthActionKind.SET_TOKEN:

            return {
                ...state,
                token: action.token,
                loggin: action.loggin,
            };
        case AuthActionKind.LOG_IN:
            return {
                ...state,
                token: action.token,
                loggin: true,
            };
        case AuthActionKind.LOG_OUT:
            return {
                ...state,
                token: '',
                loggin: false,
            };
        default:
            return state;
    }
}
